module.exports = __webpack_public_path__ + "static/media/MncTv_Indonesia.1b557f1d.png";